import * as React from 'react'
import { cn } from '@/lib/utils'

function GlobalCard({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            data-slot="global-card-container"
            className={cn(
                'bg-sidebar card-radius overflow-clip p-1.5 min-w-[320px] text-black/40 dark:text-white/40 shadow-none border border-black/3 dark:border-white/3 [contain:layout]',
                className
            )}
            {...props}
        />
    )
}

function GlobalCardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            data-slot="global-card-content"
            className={cn('p-2.5 space-y-5 rounded-[10px] bg-white card-shadow', className)}
            {...props}
        />
    )
}

function GlobalCardFallback({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            data-slot="global-card-fallback"
            className={cn(
                'bg-sidebar card-radius overflow-clip p-1.5 min-w-[320px] text-black/40 dark:text-white/40 shadow-none border border-black/3 dark:border-white/3 [contain:layout]',
                className
            )}
            {...props}
        />
    )
}

export { GlobalCard, GlobalCardContent, GlobalCardFallback }
